<template>
  <v-sheet class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
    <v-row>
      <v-col cols="12">
        <header-medium :text="$t('Authenticate.Title')" />
      </v-col>
    </v-row>

    <v-row justify="space-around">
      <v-col cols="12">
        <v-alert :color="mainColor" text type="info">
          {{ $t("info_certificate_password_2factor") }}
        </v-alert>
      </v-col>
    </v-row>

    <v-form ref="check2FactorQes">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="6" md="4" offset-md="4">
          <v-text-field v-model="password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'" :label="$t('certificate_password')" dense
            @click:append="showPassword = !showPassword" :rules="rules.password"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" offset-sm="6" md="4" offset-md="4">
          <p v-text="$t('Authenticate.keySendMessage_4')"></p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" offset-sm="6" md="4" offset-md="4">
          <v-otp-input v-model="otp" @finish="focusSubmit" :label="$t('Authenticate.EnterCode')" type="number"
            :rules="rules.password"></v-otp-input>
        </v-col>
      </v-row>
    </v-form>

    <v-row justify="center">
      <v-col cols="12" sm="5" md="5">
        <p class="text-center ma-0 pa-0 caption">
          {{ $t("Authenticate.reference") }}{{ reference }}
        </p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="5" md="5">
        <p class="text-center ma-0 pa-0 caption">
          <v-btn color="primary" @click="retrySMS" plain :disabled="disableRetry">
            <span style="white-space: normal;">{{ $t("Authenticate.NotReceivedCodeLink") }}
            </span>
          </v-btn>
        </p>
      </v-col>
    </v-row>
    <v-row v-if="smsSend" justify="center">
      <v-col cols="12" sm="12" align="center">
        <base-timer ref="timer" :time="time"></base-timer>
      </v-col>
    </v-row>
    <v-row class="pt-5" dense v-if="!mobile">
        <v-col cols="12" sm="4" class="text-left">
          <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
        </v-col>
        <v-col cols="12" sm="8" class="text-right">
          <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
          <custom-button id="sign" :disabled="disabled" :text="buttonText" @click="sign"></custom-button>
        </v-col>
      </v-row>
    <v-container class="ma-0 pa-0 mw-100" v-if="mobile">
        <v-row>
          <v-col cols="12" sm="8" class="text-center">
            <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8" class="text-center">
            <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
            <custom-button id="sign" :disabled="disabled" :text="buttonText" @click="sign"></custom-button>
          </v-col>
        </v-row>
      </v-container>
    <custom-overlay></custom-overlay>
  </v-sheet>
</template>
<script>
import CustomButton from "../../components/ui/input/CustomButton.vue";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import i18n from "@/i18n";
import BaseTimer from "../../components/ui/other/BaseTimer.vue";
import CustomOverlay from "../../components/ui/other/Overlay.vue";

export default {
  components: { CustomButton, HeaderMedium },
  name: "qes-authenticate",
  title: i18n.t("Authenticate.Title"),
  components: {
    HeaderMedium,
    CustomButton,
    BaseTimer,
    CustomOverlay,
  },
  data() {
    return {
      buttonText: "",
      mainColor: this.$vuetify.theme.themes.light.primary,
      workflow: null,
      showPassword: false,
      rules: {
        password: [(v) => !!v || this.$t("required")],
      },
      password: "",
      otp: "",
      disableRetry: true,
      time: 0,
      smsSend: false
    };
  },
  created: async function () {
    this.$emit("step", 4);
    this.workflow = this.currentWorkflow;
    this.color = this.$vuetify.theme.themes.light.primary;
    this.buttonText = this.workflow.signer_type.split("_")[1] === 'signature' ? i18n.t('Navigation.sign_now') : i18n.t('Navigation.seal_now')
    var app = this;

    await this.$store
      .dispatch("data/getSMSQualified", this.workflow)
      .then((res) => {
        this.smsSend = true;
      })
      .catch((err) => {
        return;
      }).finally(() => {
        setTimeout(function () {
          app.disableRetry = false;
        }, 60000);
      });
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    disabled() {
      return (this.$store.state.loading || this.otp.length != 6 || this.password == "") ? true : false;
    },
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
    currentFiles() {
      return this.$store.state.data.files;
    },
    reference() {
      return this.$store.state.data.reference;
    },
  },
  methods: {
    focusSubmit() {
     document.getElementById("sign").focus();
    }, 
    retrySMS() {
      this.time = 0;

      this.disableRetry = true;

      var signer = {
        workflow_id: this.workflow.workflow_id,
        signer_id: this.workflow.signer_id,
        first_name: this.workflow.first_name,
        last_name: this.workflow.last_name,
        phone: this.workflow.phone,
        email: this.workflow.email,
      };

      var app = this;

      this.$store.dispatch("data/retrySMS", signer).finally(() => {
        this.time = 300;
        setTimeout(function () {
          app.disableRetry = false;
        }, 60000);
      });
    },
    cancel() {
      this.$emit("refuse", true);
    },
    nextPage(val) {
      this.$store.state.auth.workflow = this.workflow;
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/authenticate2fa"
      );
      this.$store.commit("set_loading", true);
    },
    async sign() {
      if (this.$refs.check2FactorQes.validate()) {
        this.$store
          .dispatch("data/checkSMS", {
            workflow: this.currentWorkflow,
            auth_token: this.$store.state.data.auth_token,
            otp: this.otp,
          })
          .then(() => {
            this.$store
              .dispatch("data/checkCertificatePassword", {
                workflow: this.currentWorkflow,
                password: this.password
              })
              .then(() => {
                this.$store
                  .dispatch("data/signNowQes2Fa", {
                    workflow: this.currentWorkflow,
                    files: this.currentFiles,
                    auth_token: this.$store.state.data.auth_token,
                    otp: this.otp,
                    ip: this.currentWorkflow.ip,
                    password: this.password
                  })
                  .then(() => {
                    this.$router.push("/summary/finished");
                  })
                  .catch((err) => {
                    this.otp = "";
                  })
              })
              .catch((err) => {
                this.otp = "";
              })
          })
          .catch((err) => {
            this.otp = "";
            log("MainPage.Authenticate.sign() - " + err, "error");
          })



      }
    },
  },
};
</script>